import React from 'react';
import Constants from 'components/utils/constants';
import { withSnackbar } from 'notistack';
import { WebClientStore } from 'web-client-store';
import { AccountHandler } from 'chits-data/dist';
import { connect } from 'react-redux';
import mapStateToProps from 'reducers/actions/stateToProps';
import mapDispatchToProps from 'reducers/actions/dispatchProps';
let {Session} = WebClientStore;

class Profile extends React.Component {

    constructor(props) {
        super(props)
        this._handler = new AccountHandler();
    }

    state = {
        profile: {
            _id: 'xyz',
            name: 'Unknown',
            email: 'unknown@unknown.com',
        },
        previleges: {
            isAdmin: false
        },
        health: {
            db: '-'
        } 
    }

    componentDidMount() {
        let ac = this._handler.getActiveAccount();
        // // asynchronously load account information to props
        this._handler.getAccountCached(ac).then((account) => {
            if (account) this.props.setCurrentAccount(account);

          this.handleGetAccounts();
          this.handleGetHealthInfo();
        });
    }

    handleGetAccounts = async () => {
		let retrieveFrom = Constants.URLs.USERS + '/me';
		// this.setState({ openOverlay: true });
		this._handler.getInstance()
			.get(retrieveFrom)
			.then((response) => {
                let {user, previleges} = response.data;
                if (previleges) {
                    Session.set(Constants.SESSION_KEYS.USER_PREVILEGES, JSON.stringify(previleges));
                } else {
                    Session.unset(Constants.SESSION_KEYS.USER_PREVILEGES)
                }
				this.setState({ 
					// openOverlay: false, 
					profile: user,
                    previleges: previleges
				});
			})
			.catch((error) => {
				console.log(error);
				this.props.enqueueSnackbar('Error: Could not be able to retrieve profile information', {
					variant : 'error'
				});
			});
    }

    handleGetHealthInfo = async () => {
        let _health;
        this._handler.getInstance().get(Constants.URLs.HEALTH).then(response => {
            _health = response.data;
        }).catch(err=>{
            console.error(err)
            this.props.enqueueSnackbar('Error: unable to fetch server health information', {
                variant : 'error'
            });
        })
        .finally(()=>{
            this.setState({ 
                health: _health
             });
        })
    }

    navigateToPage = (page) => {
        this.props.history.push(page);
    }

    render() {
        let size = `0 MB`;
        let quota = 0;
        try { 
            if (this.state.profile.receipts_size) {
                size = `${(this.state.profile.receipts_size / 1024 / 1024).toFixed(3)} MB / ${(Constants.FREE_USER_RECEIPT_SIZE_QUOTA / 1024).toFixed(0)} MB`;
                quota = (((this.state.profile.receipts_size / 1024) / Constants.FREE_USER_RECEIPT_SIZE_QUOTA) * 100).toFixed(1)
            }   
        } catch (error) {
            //
        }
        // let listItem = {
        //     name: "Manage List Item",
        //     path: '/listitems',
        //     icon: 'nc-bullet-list-67',
        //     active: false
        // };
        let adminPanel = {
            name: "Admin Panel",
            path: '/admin',
            icon: 'nc-light-3',
            active: false
        };
        return (
        <div className="container-fluid">
            {/* <div className="section-image" data-image="./assets/img/bg5.jpg"
                                                        style={{backgroundImage: `url('/assets/img/full-screen-image-3.jpg')`}}> */}
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card card-user">
                                <div className="card-header no-padding">
                                    <div className="card-image">
                                        <img src="./assets/img/profile_bg.jpg" alt="..." />
                                    </div>
                                </div>
                                <div className="card-body ">
                                    <div className="author" style={{borderRadius: '0%'}}>
                                        <a href="/profile">
                                            <img className="avatar border-gray" src="./assets/img/faces/tim_vector.jpe" alt="..." />
                                            <h5 className="card-title">{this.state.profile.name}</h5>
                                        </a>
                                        <p className="card-description">
                                            {this.state.profile.email}
                                        </p>
                                    </div>
                                    {/* <p className="card-description text-center">
                                        Hey there! As you can see,
                                        <br /> more text here
                                    </p> */}
                                    <div className="form-group">
                                        <label>Receipts size quota</label>
                                        <input type="text" className="form-control" placeholder="Receipts" 
                                            value={size + ' (' + quota + ' %)'} readOnly />
                                        <div className="progress">
                                            <div className="progress-bar" role="progressbar" style={{ width: `${quota}%` }}
                                            aria-valuenow={quota} aria-valuemin="0" aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                                {this.state.previleges.isAdmin && 
                                <div className="card-footer ">
                                    <hr />
                                    <div className="row">
                                        <div className="col-md-12 pr-1">
                                            <div>
                                                <p className="card-description">
                                                    [{JSON.stringify(this.state.health)}]
                                                </p>
                                                {/* <label>Connected Database:</label>
                                                <input type="text" className="form-control" placeholder="City" value={this.state.health.db} readOnly /> */}
                                            </div>
                                        </div>
                                    </div>
                                    <div className="button-container text-center">
                                        {/* <button href="#" className="btn btn-simple btn-link btn-icon"
                                            onClick={() => this.navigateToPage("/listitems")}>
                                            <i className={`nc-icon ${listItem.icon} icon-bold`}> List Items</i>
                                        </button> */}
                                        <button href="#" className="btn btn-simple btn-link btn-icon"
                                            onClick={() => this.navigateToPage("/admin")}>
                                            {/* <i className="fa fa-twitter"></i> */}
                                            <i className={`nc-icon ${adminPanel.icon} icon-bold`}> Admin Panel</i>
                                        </button>
                                        {/* <button href="#" className="btn btn-simple btn-link btn-icon">
                                            <i className="fa fa-google-plus-square"></i>
                                        </button> */}
                                    </div>
                                </div>
                                }     
                            </div>
                        </div>
                        {/* <div className="col-md-6">
                            <form className="form" method="" action="">
                                <div className="card ">
                                    <div className="card-header ">
                                        <div className="card-header">
                                            <h4 className="card-title">Profile Information</h4>
                                        </div>
                                    </div>
                                    <div className="card-body ">
                                        <div className="row">
                                            <div className="col-md-12 pl-1">
                                                <div className="form-group">
                                                    <label>First Name</label>
                                                    <input type="text" className="form-control" placeholder="First Name" value={this.state.profile.name} readOnly />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 pl-1">
                                                <div className="form-group">
                                                    <label>Last Name</label>
                                                    <input type="text" className="form-control" placeholder="Last Name" value="" readOnly />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 pl-1">
                                                <div className="form-group">
                                                    <label>Email address</label>
                                                    <input type="email" className="form-control" placeholder="Email" value={this.state.profile.email} readOnly />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 pl-1">
                                                <div className="form-group">
                                                    <label>Receipts size quota</label>
                                                    <input type="text" className="form-control" placeholder="Receipts" value={size + ' (' + quota + ')'} readOnly />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="clearfix"></div>
                                    </div>
                                </div>
                            </form>
                        </div> */}
                    </div>
                </div>
            {/* </div> */}
        </div>
        )
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(Profile));